export enum GTMEvent {
  VirtualPageView = "virtual_pageView",
  ViewItemList = "view_item_list",
  SelectItem = "select_item",
  ViewItem = "view_item",
  AddToCart = "add_to_cart",
  RemoveFromCart = "remove_from_cart",
  BeginCheckout = "begin_checkout",
  Purchase = "purchase",
}
